import React from 'react';
import { CenterFrameLayout } from 'Layouts';
import { SecondaryText } from 'Components/Texts';

export const SignInRedirectLoader = ({ title, secondaryText }) => (
  <CenterFrameLayout title={title} showLoader={false}>
    <div className="signInFormContainer">
      <SecondaryText alignText="centerText" text={secondaryText} />
    </div>
  </CenterFrameLayout>
);
